// extracted by mini-css-extract-plugin
export default {"container":"cM_g","checkbox":"cM_kM","isActive":"cM_hd","checkboxIcon":"cM_kN","text":"cM_cZ"};